import Vue from 'vue';
import geralRouter from './geral-router';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [].concat(geralRouter);

const router = new VueRouter({
    mode:'history',
    routes
  });

  export default router;
